import {
  BMBadgeTag,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import { useCallback } from "react";
import { Pressable, StyleSheet } from "react-native";
import HighlightText from "../../../../components/HighlightText/HighlightText";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { useHotelAutocomplete } from "../../../../providers/api/HotelAutocompleteContext";
import { HotelSearchResponseItem } from "./types";

type Props = {
  item: HotelSearchResponseItem;
  query: string;
  onCloseDialog: () => void;
  testID?: string;
};

export default function SearchResultItem(props: Props) {
  const { item, query, onCloseDialog, testID } = props;
  const bmTheme = useBMTheme();
  const { handleSelectSearchItem } = useHotelAutocomplete();
  const { CorporateHotelSearchForm } = useMobileContentResource();

  const getBadgeText = useCallback(
    (type: string) => {
      switch (type) {
        case "HOTEL":
          return CorporateHotelSearchForm.destinationTypeHotel;
        case "LANDMARK":
          return CorporateHotelSearchForm.destinationTypeLandmark;
        case "REGION":
        default:
          return CorporateHotelSearchForm.destinationTypeRegion;
      }
    },
    [CorporateHotelSearchForm]
  );

  function handleSelectItem() {
    handleSelectSearchItem(item);
    onCloseDialog();
  }
  return (
    <Pressable onPress={handleSelectItem} testID={testID}>
      <BMView
        row
        justify="between"
        style={[
          styles.container,
          {
            borderBottomColor: bmTheme.BMComponents.BMStyleTextInkPrimaryInvert,
          },
        ]}
      >
        <BMView>
          <HighlightText
            keyword={query}
            searchedText={item.name}
            defaultTextProps={{
              variant: "uiLarge",
              ink: "BMStyleTextInkPrimary",
              numberOfLines: 1,
              ellipsizeMode: "tail",
              style: styles.text,
            }}
            highlightTextProps={{
              variant: "uiLarge",
              ink: "BMUiButtonInkSecondary",
              numberOfLines: 1,
              ellipsizeMode: "tail",
            }}
          />
          <BMText
            numberOfLines={1}
            ellipsizeMode="tail"
            variant="uiNormalLi"
            ink="BMStyleTextInkSecondary"
            style={styles.text}
          >
            {item.location}
          </BMText>
        </BMView>
        <BMView
          style={{
            width: 80,
          }}
          align="center"
          spacing="xs"
        >
          <BMView>
            <BMBadgeTag type="BLUE" label={getBadgeText(item.type)} />
          </BMView>
          {!!Number(item.numOfHotels) && (
            <BMText>{item.numOfHotels} hotels</BMText>
          )}
        </BMView>
      </BMView>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    borderBottomWidth: BMPrimitives.BMStroke.sm,
    paddingBottom: BMPrimitives.BMSize.sm,
  },
  text: {
    width: 247,
    overflow: "hidden",
  },
});
